import { QuickfireForceChipSizeCommand } from "quickfire/commands/quickfire-force-chip-size-command";
import State from "slotworks/state-machine/states/state";

export default class QuickfireRecoverStake extends State {

    public onEnter() {
        QuickfireForceChipSizeCommand().then(() => this.complete());
    }
}
